import { AutogenModelEdiPartnerCode, AutogenRowEdiPartnerCode } from "./autogen/AutogenModelEdiPartnerCode";

export class ModelEdiPartnerCode extends AutogenModelEdiPartnerCode<RowEdiPartnerCode> {
    constructor() {
        super(RowEdiPartnerCode);
    }
}

export class RowEdiPartnerCode extends AutogenRowEdiPartnerCode {
}